import React from 'react';
import { Outlet } from 'react-router-dom';

import { useLogoutMutation } from '@/store/api/authApi';
import { DashboardHeader } from '@/components/common/DashboardHeader';
import { StepProvider } from '@/context/StepProvider';

export function DashboardLayout() {
  const [logout] = useLogoutMutation();

  return (
    <div className="min-h-screen bg-black">
      <StepProvider>
        <DashboardHeader />

        <div className="">
          <main className="flex-1 p-4 lg:p-6">
            <Outlet />
          </main>
        </div>
      </StepProvider>
    </div>
  );
}
